/**
 * Downloads the given data as a file with the given name.
 *
 * This is not used in production code to directly download the export, but is
 * used for testing purposes.
 */
export const saveBuffer = (buffer: ArrayBuffer, filename: string) => {
    var blob = new Blob( [ buffer ], { type: 'application/octet-stream' } );
    const link = document.createElement('a');
    link.href = URL.createObjectURL( blob );
    link.download = filename;
    link.click();
}
